import { Avatar, Box, Flex, Heading, Text } from '@chakra-ui/react';
import { FC } from 'react';

import { ThinProfile } from '@/resources/ThinProfile';

interface IProfileListModalPage {
  profiles: Array<ThinProfile>;
  setProfileSelected: (profile: ThinProfile) => void;
}

export const ProfileListModalPage: FC<IProfileListModalPage> = ({ profiles, setProfileSelected }) => {
  return (
    <Flex flexDir="column" w="full" maxW={{ base: '335px', md: '600px' }} maxH="400px" overflowY="auto" pb={2} gap={2}>
      {profiles.map((p) => (
        <Flex
          onClick={() => setProfileSelected(p)}
          _hover={{
            boxShadow: '0px 16px 32px 0px #0000001A',
          }}
          key={p.id}
          alignItems="center"
          py={4}
          px={2}
          rounded={8}
          cursor="pointer"
        >
          <Box mr={{ base: 4, md: 8 }}>
            <Avatar bg="transparent" color="white" name={p.fullName} src={p.avatar} boxSize={{ base: '60px' }} />
          </Box>
          <Flex flexDir="column">
            <Heading fontSize="xl">{p.fullName}</Heading>
            <Text fontFamily="body" fontSize={14}>
              {p.title}
            </Text>
          </Flex>
        </Flex>
      ))}
    </Flex>
  );
};
